import config from './config';
import { featureToggle } from './featureToggle';

export { featureToggle };
export default config;
